import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Document, Page, Text, Svg, Path, Polyline, Rect, View, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer'; // Using react-pdf for PDF generation
import {formatNumberWithCustomSymbol} from '../assets/salaryformat';

const ExportPDFBiodataSupplier = ({ data, supplier }) => { 
  // Reusable Header Component
  const employmentList = data?.employment || [];



  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();


    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  }
  const parseDMYToDate = (dmy) => {
    const [day, month, year] = dmy.split("/");

    return new Date(`${year}-${month}-${day}`);
  }
  
 
  const Header = ({ supplier }) => {

    let logo,companty_name, street, postal_code, phone;
    if(data.admin_company_info){

      logo = data.admin_company_info?.logo || '';
      companty_name = data.admin_company_info?.name || '';
      street = data.admin_company_info?.street || '';
      postal_code = data.admin_company_info?.postal_code || '';
      phone = data.admin_company_info?.phone || '';
    }else {
      logo = supplier.imgprofile || '';
      companty_name = supplier.company_name || '';
      street = supplier.street || '';
      postal_code = supplier.postal_code || '';
      phone = supplier.phone || '';
    }

    return (
      <View style={[styles.header]}>
        {logo && (
          <Image
            src={logo} // Ensure this is a full valid URL
            style={styles.logo}
          />
        )}
        <Text style={styles.headerText}>
          {companty_name}
          {"\n"}
          {street} , {postal_code}
          {"\n"}
          {phone}
        </Text>
      </View>
    );
  };

      
  
  // PDF Document with react-pdf
  return (
    // <PDFViewer>
      <Document>
      <Page size="A4" style={styles.body}>
        <Header supplier={supplier} />
        <View style={[styles.center, {marginBottom: 6, marginTop: 10}]}>
          <Text style={{fontWeight: 'bold'}}>BIO-DATA OF FOREIGN DOMESTIC WORKER (FDW)</Text>
        </View>
        <View>
          <Text style={{fontSize: 8}}>*Please ensure that you run through the information within the biodata as it is an important document to help you select a suitable FDW</Text>
        </View>

        <View style={[styles.section, {marginTop: 15}]}>
          <View style={{width: '60%', paddingRight: 10}}>
            
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>(A)</Text>
              <Text>PROFILE OF FDW</Text>
            </View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>A1</Text>
              <Text>Personal Information</Text>
            </View>

            <View style={styles.formText}>
              <Text>1. Name:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.name ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <View style={[styles.formText, {width: '60%', marginBottom: 0}]}>
                <Text>2. Date of Birth:</Text>
                <View style={[styles.fullWidthUnderline, {paddingRight: 5}]}>
                  <Text> {data.dob ?? ' '}</Text>
                </View>
              </View>
              <View style={[styles.formText, {width: '40%', marginBottom: 0}]}>
                <Text style={{paddingLeft: 5}}>Age:</Text>
                <View style={[styles.fullWidthUnderline]}>
                  <Text> {data.dob ? calculateAge(parseDMYToDate(data.dob)) : ' '}</Text>
                </View>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>3. Place of Birth:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.pob ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <View style={[styles.formText, {width: '60%', marginBottom: 0}]}>
                <Text>4. Height & Weight:</Text>
                <View style={[styles.fullWidthUnderline, {paddingRight: 5}]}>
                  <Text> {data.height ?? ' '}</Text>
                </View>
              </View>
              <View style={[styles.formText, {width: '40%', marginBottom: 0}]}>
                <Text style={{paddingLeft: 5}}>cm</Text>
                <View style={[styles.fullWidthUnderline]}>
                  <Text> {data.weight ?? ' '}</Text>
                </View>
                <Text style={{paddingLeft: 5}}>kg</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>5. Nationality:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.nationality ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>6. Residential address in home country:</Text>
            </View>
            <View style={styles.formText}>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.address ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>7. Name of port / airport to repatriated to:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.airport ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>8. Contact number in home country:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.contact ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>9. Religion:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.religion ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>10. Educational Level:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.education ?? ' '}</Text>
              </View>
            </View>
          </View>

          <View style={{width: '40%'}}>
            <View style={{ flex: 1, alignItems: "center", justifyContent: "center", marginBottom: 6 }}>
              {data.imgprofile ? (
                      <View style={{flex: 1, maxHeight: 150, borderWidth: 1, borderColor: 'black', alignItems: 'center', justifyContent: 'center'}}>
                        <Image
                          src={data.imgprofile} // Ensure this is a full valid URL
                          style={styles.photo}
                        />
                      </View>
                    ) : (
                      <View style={{flex: 1, height: 150, borderWidth: 1, borderColor: 'black', alignItems: 'center', justifyContent: 'center'}}>
                        <Text style={{marginBottom: 20}}>Photo</Text>
                        <Text>(half/full bodied and coloured)</Text>
                      </View>
                    )}
            </View>
            <View style={styles.formText}>
              <Text>11. Number of Siblings:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.siblings ?? ' '}</Text>
              </View>
            </View>
            
            <View style={styles.formText}>
              <Text>12. Marital Status:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.marital ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>13. Number of children:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.children_age ? data.children_age.length : ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>Age(s) of children (if any):</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> { data.children_age ? data.children_age.join(', ') : ''} </Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>Passport:</Text>
              <View style={[styles.fullWidthUnderline]}>
                <Text> {data.passport ?? ' '}</Text>
              </View>
            </View>
            <View style={styles.formText}>
              <Text>Salary:</Text>
              <View style={[styles.fullWidthUnderline]}>
               <Text>
                {formatNumberWithCustomSymbol(data.salaries.SGD) }
                 {/*formatNumberWithCustomSymbol(data.salaries.SGD) + '  ' + formatNumberWithCustomSymbol(data.salaries.MYR)*/}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View>
          <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
            <Text style={{marginRight: 10}}>A2</Text>
            <Text>Medical History/Dietary Restrictions</Text>
          </View>
          <View style={styles.formText}>
            <Text>14. Allergies (if any):</Text>
            <View style={[styles.fullWidthUnderline]}>
              <Text> {data.allergies ?? ' '}</Text>
            </View>
          </View>
          <View style={{marginBottom: 6}}>
            <Text style={{marginBottom: 6}}>15. Past and existing illnesses (including chronic ailments and illnesses requiring medication):</Text>
            <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
              <View style={{width: '50%'}}>
                <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                  <View style={{width: '50%'}}>
                    <Text style={{marginBottom: 6}}> </Text>
                    <Text style={{marginBottom: 6}}>i. Mental illness</Text>
                    <Text style={{marginBottom: 6}}>ii. Epilepsy</Text>
                    <Text style={{marginBottom: 6}}>iii. Asthma</Text>
                    <Text style={{marginBottom: 6}}>iv. Diabetes</Text>
                    <Text style={{marginBottom: 6}}>v. Hypertension</Text>
                  </View>
                  <View style={{width: '50%'}}>
                    <View style={{flexDirection: 'row'}}>
                      <Text style={{marginBottom: 6, marginRight: 10}}>Yes</Text>
                      <Text>No</Text>
                    </View>
                    <View style={{flexDirection: 'row', marginBottom: 9}}>
                      {(data.illnesses.find((el) => el == 'Mental illness' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                      }
                      {(data.illnesses.find((el) => el == 'Mental illness' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                      }
                    </View>
                    <View style={{flexDirection: 'row', marginBottom: 9}}>
                      {(data.illnesses.find((el) => el == 'Epilepsy' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                      }
                      {(data.illnesses.find((el) => el == 'Epilepsy' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                      }
                    </View>
                    <View style={{flexDirection: 'row', marginBottom: 9}}>
                      {(data.illnesses.find((el) => el == 'Asthma' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                      }
                      {(data.illnesses.find((el) => el == 'Asthma' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                      }
                    </View>
                    <View style={{flexDirection: 'row', marginBottom: 9}}>
                      {(data.illnesses.find((el) => el == 'Diabetes' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                      }
                      {(data.illnesses.find((el) => el == 'Diabetes' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                      }
                    </View>
                    <View style={{flexDirection: 'row', marginBottom: 9}}>
                      {(data.illnesses.find((el) => el == 'Hypertension' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                      }
                      {(data.illnesses.find((el) => el == 'Hypertension' )) ? 
                        (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Rect
                              x="3" // Starting x-coordinate
                              y="3" // Starting y-coordinate
                              width="18" // Width of the square
                              height="18" // Height of the square
                              rx="2" // Corner radius (rounded corners)
                              ry="2" // Corner radius for y-axis
                              stroke="currentColor" // Outline color
                              strokeWidth={2} // Outline thickness
                              fill="none" // No fill color
                            />
                          </Svg>
                        )
                        : (
                          <Svg style={styles.icon} viewBox="0 0 24 24">
                            <Polyline
                              points="9 11 12 14 22 4" // Coordinates for the check mark
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                            <Path
                              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </Svg>
                        )
                      }
                    </View>
                  </View>
                </View>
              </View>
              <View style={{width: '50%'}}>
                <View>
                  <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                    <View style={{width: '50%'}}>
                      <Text style={{marginBottom: 6}}> </Text>
                      <Text style={{marginBottom: 6}}>vi. Tuberculosis</Text>
                      <Text style={{marginBottom: 6}}>vii. Heart disease</Text>
                      <Text style={{marginBottom: 6}}>viii. Malaria</Text>
                      <Text style={{marginBottom: 6}}>ix. Operations</Text>
                    </View>
                    <View style={{width: '50%'}}>
                      <View style={{flexDirection: 'row'}}>
                        <Text style={{marginBottom: 6, marginRight: 10}}>Yes</Text>
                        <Text>No</Text>
                      </View>
                      <View style={{flexDirection: 'row', marginBottom: 9}}>
                        {(data.illnesses.find((el) => el == 'Tuberculosis' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                        }
                        {(data.illnesses.find((el) => el == 'Tuberculosis' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                        }
                      </View>
                      <View style={{flexDirection: 'row', marginBottom: 9}}>
                        {(data.illnesses.find((el) => el == 'Heart disease' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                        }
                        {(data.illnesses.find((el) => el == 'Heart disease' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                        }
                      </View>
                      <View style={{flexDirection: 'row', marginBottom: 9}}>
                        {(data.illnesses.find((el) => el == 'Malaria' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                        }
                        {(data.illnesses.find((el) => el == 'Malaria' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                        }
                      </View>
                      <View style={{flexDirection: 'row', marginBottom: 9}}>
                        {(data.illnesses.find((el) => el == 'Operations' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                        }
                        {(data.illnesses.find((el) => el == 'Operations' )) ? 
                          (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Rect
                                x="3" // Starting x-coordinate
                                y="3" // Starting y-coordinate
                                width="18" // Width of the square
                                height="18" // Height of the square
                                rx="2" // Corner radius (rounded corners)
                                ry="2" // Corner radius for y-axis
                                stroke="currentColor" // Outline color
                                strokeWidth={2} // Outline thickness
                                fill="none" // No fill color
                              />
                            </Svg>
                          )
                          : (
                            <Svg style={styles.icon} viewBox="0 0 24 24">
                              <Polyline
                                points="9 11 12 14 22 4" // Coordinates for the check mark
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                              <Path
                                d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          )
                        }
                      </View>
                    </View>
                  </View>
                </View>
                <View style={styles.formText}>
                  <Text>x. Others:</Text>
                  <View style={[styles.fullWidthUnderline]}>
                    <Text> </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.formText}>
            <Text>16. Physical disabilities:</Text>
            <View style={[styles.fullWidthUnderline]}>
              <Text> {data.disabilities ?? ' '}</Text>
            </View>
          </View>
          <View style={styles.formText}>
            <Text>17. Dietary restrictions:</Text>
            <View style={[styles.fullWidthUnderline]}>
              <Text> {data.diet ?? ' '}</Text>
            </View>
          </View>
        </View>
        <View style={{marginTop: 10}}>
          <View style={styles.formText}>
            <Text>18. Food handling preferences:</Text>
            {data.food_preference.pork ? 
              (
                <Svg style={[styles.icon, {marginLeft: 15, marginRight: 2}]} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={[styles.icon, {marginLeft: 15, marginRight: 2}]} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text>No Pork</Text>
            {data.food_preference.beef ? 
              (
                <Svg style={[styles.icon, {marginLeft: 15, marginRight: 2}]} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={[styles.icon, {marginLeft: 15, marginRight: 2}]} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text>No Beef</Text>
            {data.food_preference.other ? 
              (
                <Svg style={[styles.icon, {marginLeft: 15, marginRight: 2}]} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={[styles.icon, {marginLeft: 15, marginRight: 2}]} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text>Others:</Text>
            <View style={[styles.fullWidthUnderline]}>
              <Text> {data.food_preference.other ?? ' '}</Text>
            </View>
          </View>
          <View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>A3</Text>
              <Text>Others</Text>
            </View>
            <View style={styles.formText}>
              <Text>19. Preference for rest day:</Text>
              <View style={{ width: '5%', borderBottomWidth: 1, borderBottomColor: 'black', marginLeft: 8}}>
                <Text> {data.rest_day ?? ' '}</Text>
              </View>
              <Text style={{paddingLeft: 5}}>rest day(s) per month.</Text>
            </View>
            <View style={styles.formText}>
              <Text>20. Any other remarks:</Text>
              <View style={[styles.fullWidthUnderline, {lineHeight: 1}]}>
                <Text> {data.other_remarks ?? ' '}</Text>
              </View> 
            </View>
          </View>
          <View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>(B)</Text>
              <Text>SKILLS OF FDW</Text>
            </View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>B1</Text>
              <Text>Method of Evaluation of Skills</Text>
            </View>
            <View style={{flexDirection: 'row', marginBottom: 6}}>
              {(data.fdw_declaration) ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text> Please indicate the method(s) used to evaluate the FDW’s skills (can tick more than one):</Text>
            </View>
            <View style={{flexDirection: 'row', marginBottom: 6}}>
              {(data.singapore_ea) ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text> Interviewed by Singapore EA:</Text>
            </View>
            <View style={{flexDirection: 'row', marginLeft: 10, marginBottom: 6}}>
              {(data.interview_method.find((el) => el === 'Phone' )) ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text> Interviewed via telephone/teleconference</Text>
            </View>
            <View style={{flexDirection: 'row', marginLeft: 10, marginBottom: 6}}>
              {(data.interview_method.find((el) => el === 'Video' )) ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text> Interviewed via videoconference</Text>
            </View>
            <View style={{flexDirection: 'row', marginLeft: 10, marginBottom: 6}}>
              {(data.interview_method.find((el) => el === 'In Person' )) ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text> Interviewed via person</Text>
            </View>
            <View style={{flexDirection: 'row', marginLeft: 10, marginBottom: 6}}>
              {(data.interview_method.find((el) => el === 'Observation' )) ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text> Interviewed via person and also made observation of FDW in the areas of work listed in table</Text>
            </View>
            <View style={styles.table}>
              {/* Header Row */}
              <View style={styles.tableRow} wrap={false}>
                <Text style={[styles.tableCell, styles.headerCell, {width: '5%'}]}>S/N</Text>
                <Text style={[styles.tableCell, styles.headerCell, {width: '25%'}]}>Areas of Work</Text>
                <Text style={[styles.tableCell, styles.headerCell, {width: '15%'}]}>
                  Willingness
                  {"\n"}
                  <Text style={{fontWeight: 'normal', fontSize: 8}}>Yes/No</Text>
                </Text>
                <Text style={[styles.tableCell, styles.headerCell, {width: '15%'}]}>
                  Experience
                  {"\n"}
                  <Text style={{fontWeight: 'normal', fontSize: 8}}>Yes/No</Text>
                  {"\n"}
                  <Text style={{fontWeight: 'normal', fontSize: 8}}>
                    If yes,state
                    the no. of
                    years
                  </Text>
                </Text>
                <Text style={[styles.tableCell, styles.headerCell, {width: '40%'}]}>
                  Assessment/Observation
                  {"\n"}
                  <Text style={{fontWeight: 'normal', fontSize: 8}}>
                    Please state qualitative observations of FDW and/or rate the FDW (indicate N.A. of no evaluation was done)
                  </Text>
                  {"\n"}
                  <Text style={{fontWeight: 'normal', fontSize: 8}}>
                  Poor……………………Excellent...N.A
                  {"\n"}
                  1 2 3 4 5 N.A
                  </Text>
                </Text>
              </View>
              {/* Data Rows */}
              <View style={styles.tableRow} wrap={false}>
                <Text style={[styles.tableCell, {width: '5%'}]}>1</Text>
                <View style={[styles.tableCell, {width: '25%'}]}> 
                  <Text>
                    Care of infants/children
                    {"\n"}
                    Please specify age range:
                    {"\n"}
                  </Text>
                  <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 5}}>
                    <View style={[styles.fullWidthUnderline, {marginLeft: 0}]}>
                      <Text> {data.areas_of_work.infants.extra}</Text>
                    </View>
                  </View>
                </View>
                <Text style={[styles.tableCell, {width: '15%'}]}>{data.areas_of_work.infants.willing ? 'Yes' : 'No'}</Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>
                  {data.areas_of_work.infants.experience ? 'Yes' : 'No'}
                  {"\n"}
                  {data.areas_of_work.infants.experience ? (data.areas_of_work.infants.experience_years ?? <></>) : <></>}
                </Text>
                <Text style={[styles.tableCell, {width: '40%'}]}> {data.areas_of_work.infants.rating ?? ''} </Text>
              </View>
              <View style={styles.tableRow} wrap={false}>
                <Text style={[styles.tableCell, {width: '5%'}]}>2</Text>
                <Text style={[styles.tableCell, {width: '25%'}]}> 
                  Care of elderly
                </Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>{data.areas_of_work.elderly.willing ? 'Yes' : 'No'}</Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>
                  {data.areas_of_work.elderly.experience ? 'Yes' : 'No'}
                  {"\n"}
                  {data.areas_of_work.elderly.experience ? (data.areas_of_work.infants.experience_years ?? <></>) : <></>}
                </Text>
                <Text style={[styles.tableCell, {width: '40%'}]}> { data.areas_of_work.elderly.rating ?? '' } </Text>
              </View>
              <View style={styles.tableRow} wrap={false}>
                <Text style={[styles.tableCell, {width: '5%'}]}>3</Text>
                <Text style={[styles.tableCell, {width: '25%'}]}> 
                  Care of disabled
                </Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>{data.areas_of_work.disabled.willing ? 'Yes' : 'No'}</Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>
                  {data.areas_of_work.elderly.experience ? 'Yes' : 'No'}
                  {"\n"}
                  {data.areas_of_work.disabled.experience ? (data.areas_of_work.disabled.experience_years ?? <></>) : <></>}
                </Text>
                <Text style={[styles.tableCell, {width: '40%'}]}> { data.areas_of_work.disabled.rating ?? ' ' } </Text>
              </View>
              <View style={styles.tableRow} wrap={false}>
                <Text style={[styles.tableCell, {width: '5%'}]}>4</Text>
                <Text style={[styles.tableCell, {width: '25%'}]}> 
                  Care of housework
                </Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>{data.areas_of_work.housework.willing ? 'Yes' : 'No'}</Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>
                  {data.areas_of_work.housework.experience ? 'Yes' : 'No'}
                  {"\n"}
                  {data.areas_of_work.housework.experience ? (data.areas_of_work.housework.experience_years ?? <></>) : <></>}
                </Text>
                <Text style={[styles.tableCell, {width: '40%'}]}> { data.areas_of_work.housework.rating ?? ' ' } </Text>
              </View>
              <View style={styles.tableRow} wrap={false}>
                <Text style={[styles.tableCell, {width: '5%'}]}>5</Text>
                <View style={[styles.tableCell, {width: '25%'}]}>
                  <Text> 
                    Cooking
                    {"\n"}
                    Please specify cuisines:
                  </Text>
                  <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 5}}>
                    <View style={[styles.fullWidthUnderline, {marginLeft: 0}]}>
                      <Text> {data.areas_of_work.cooking.extra}</Text>
                    </View>
                  </View>
                </View>
                <Text style={[styles.tableCell, {width: '15%'}]}>{data.areas_of_work.cooking.willing ? 'Yes' : 'No'}</Text>
                <Text style={[styles.tableCell, {width: '15%'}]}>
                  {data.areas_of_work.cooking.experience ? 'Yes' : 'No'}
                  {"\n"}
                  {data.areas_of_work.cooking.experience ? (data.areas_of_work.cooking.experience_years ?? <></>) : <></>}
                </Text>
                <Text style={[styles.tableCell, {width: '40%'}]}> { data.areas_of_work.cooking.rating ?? ' ' } </Text>
            </View>
            <View style={styles.tableRow} wrap={false}>
              <Text style={[styles.tableCell, {width: '5%'}]}>6</Text>
              <View style={[styles.tableCell, {width: '25%'}]}> 
                <Text>
                Language abilities (spoken)
                {"\n"}
                Please specify: 
                </Text>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <View style={[styles.fullWidthUnderline, {marginLeft: 0}]}>
                    <Text>
                    {data.languages.join(", ")}
                    </Text>
                  </View>
                </View>
              </View>
              <Text style={[styles.tableCell, {width: '15%'}]}> </Text>
              <Text style={[styles.tableCell, {width: '15%'}]}> </Text>
              <Text style={[styles.tableCell, {width: '40%'}]}> </Text>
            </View>
            <View style={styles.tableRow} wrap={false}>
              <Text style={[styles.tableCell, {width: '5%'}]}>7</Text>
              <View style={[styles.tableCell, {width: '25%'}]}> 
                <Text>
                  Other skills (if any)
                  {"\n"}
                  Please specify: 
                </Text>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <View style={[styles.fullWidthUnderline, {marginLeft: 0}]}>
                    <Text>{data.other_skills}</Text>
                  </View>
                </View>
              </View>
              <Text style={[styles.tableCell, {width: '15%'}]}> </Text>
              <Text style={[styles.tableCell, {width: '15%'}]}> </Text>
              <Text style={[styles.tableCell, {width: '40%'}]}> </Text>
            </View>
            </View>
          </View>
        </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            {(data.overseas_training) ? 
              (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <View style={{flexDirection: 'row', marginBottom: 6}}>
              <Text> Interviewed by overseas training centre/EA (Please state name of foreign training centre/EA:</Text>
              <View style={styles.fullWidthUnderline}>{data.foreign_training_centre}</View>
              <Text>)</Text>
            </View>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            <Text>  State if the third party is certified (e.g.ISO9001) or audited periodically by the EA:</Text>
            <View style={styles.fullWidthUnderline}>{data.certification}</View>
          </View>
          <View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>(C)</Text>
              <Text>EMPLOYMENT HISTORY OF THE FDW</Text>
            </View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>C1</Text>
              <Text>Employment History Overseas</Text>
            </View>
          </View>
          <View style={styles.table}>
            {/* Header Row */}
            <View style={styles.tableRow2} wrap={false}>
              <View style={[styles.tableCellMerged, styles.headerCell, { width: '35%', alignItems: 'center', borderWidth: 1, borderColor: 'black'}]}>
                <Text style={{ height: 25, alignItems: 'center' }}>Date</Text>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={[styles.tableCell, styles.headerCell, { width: '50%' }]}>From</Text>
                  <Text style={[styles.tableCell, styles.headerCell, { width: '50%' }]}>To</Text>
                </View>
              </View>
              <Text style={[styles.tableCell, styles.headerCell, { width: '20%' }]}>Country (including FDW’s homecountry)</Text>
              <Text style={[styles.tableCell, styles.headerCell, { width: '15%' }]}>Employer</Text>
              <Text style={[styles.tableCell, styles.headerCell, { width: '30%' }]}>Work Duties</Text>
              {/* <Text style={[styles.tableCell, styles.headerCell, { width: '15%' }]}>Remarks</Text> */}
            </View>

            {/* Wrap dynamic rows in a no-wrap container */}
            <View>
              {employmentList.map((row, index) => (
                <View key={index} style={styles.tableRow3} wrap={false}>
                  <Text style={[styles.tableCell, { width: '17.5%' }]}>{row.employment_from}</Text>
                  <Text style={[styles.tableCell, { width: '17.5%' }]}>{row.employment_to}</Text>
                  <Text style={[styles.tableCell, { width: '20%' }]}>{row.employment_country}</Text>
                  <Text style={[styles.tableCell, { width: '15%' }]}>{row.employment_employer}</Text>
                  <Text style={[styles.tableCell, { width: '30%', lineHeight: 1 }]}>{row.employment_duties}</Text>
                  {/* <Text style={[styles.tableCell, { width: '15%' }]} /> */}
                </View>
              ))}
            </View>
          </View>

          <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
            <Text style={{marginRight: 10}}>C2</Text>
            <Text>Employment History in Singapore</Text>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            <Text>Previous working experience in Singapore</Text>
            <View style={{flexDirection: 'row', marginLeft: 30}}>
              {(data.singapore_experience) == 'Yes' || (data.singapore_experience) == 'yes' ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text>Yes</Text>
            </View>
            <View style={{flexDirection: 'row', marginLeft: 30}}>
              {(data.singapore_experience) == 'No' || (data.singapore_experience) == 'no' ? 
                (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Polyline
                      points="9 11 12 14 22 4" // Coordinates for the check mark
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <Path
                      d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </Svg>
                )
                : (
                  <Svg style={styles.icon} viewBox="0 0 24 24">
                    <Rect
                      x="3" // Starting x-coordinate
                      y="3" // Starting y-coordinate
                      width="18" // Width of the square
                      height="18" // Height of the square
                      rx="2" // Corner radius (rounded corners)
                      ry="2" // Corner radius for y-axis
                      stroke="currentColor" // Outline color
                      strokeWidth={2} // Outline thickness
                      fill="none" // No fill color
                    />
                  </Svg>
                )
              }
              <Text>No</Text>
            </View>
          </View>
          <Text style={{marginBottom: 6}}>
            (The EA is required to obtain the FDW’s employment history from MOM and furnish the employer with the employment history of the FDW. The employer may verify the FDW’s employment history in Singapore through WPOLusing SingPass)
          </Text>
         

          <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
            <Text style={{marginRight: 10}}>C3</Text>
            <Text>Feedback from previous employers in Singapore</Text>
          </View>
          <Text style={{marginBottom: 6}}>
            Feedback was/was not obtained by the EA from the previous employers. If feedback was obtained (attach testimonial if possible), please indicate the feedback in the table below:
          </Text>
          {
            (data.feedback_employer_1 || data.feedback_employer_2) && (
              <View style={styles.table}>
                {/* Header Row */}
                {
                  (data.feedback_employer_1 || data.feedback_employer_2) && (
                    <View style={styles.tableRow2} wrap={false}>
                      <Text style={[styles.tableCell, styles.headerCell, {width: '25%'}]}> </Text>
                      <Text style={[styles.tableCell, styles.headerCell, {width: '75%'}]}>Feedback</Text>
                    </View>
                  )
                }
                {
                  data.feedback_employer_1 && (
                    <View style={styles.tableRow} wrap={false}>
                      <Text style={[styles.tableCell, {width: '25%'}]}>Employer 1</Text>
                      <Text style={[styles.tableCell, {width: '75%', lineHeight: 1}]}>{data.feedback_employer_1}</Text>
                    </View>
                  )
                }
               {
                  data.feedback_employer_2 && (
                     <View style={styles.tableRow} wrap={false}>
                        <Text style={[styles.tableCell, {width: '25%'}]}>Employer 2</Text>
                        <Text style={[styles.tableCell, {width: '75%', lineHeight: 1}]}>{data.feedback_employer_2}</Text>
                      </View>
                  )
               }
              </View> 
            )
          }


        <View style={{marginTop: 10}}>
          <View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>(D)</Text>
              <Text>AVAILABILITY OF FDW TO BE INTERVIEWED BY PROSPECTIVE EMPLOYER</Text>
            </View>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            {(data.interview_availability.find((el) => el === 'Not_available' )) ? 
              (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text> FDW is not available for interview</Text>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            {(data.interview_availability.find((el) => el === 'Phone' )) ? 
              (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text> FDW can be interviewed by phone</Text>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            {(data.interview_availability.find((el) => el === 'Video' )) ? 
              (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text> FDW can be interviewed by video-conference</Text>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 20}}>
            {(data.interview_availability.find((el) => el === 'In Person' )) ? 
              (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Polyline
                    points="9 11 12 14 22 4" // Coordinates for the check mark
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <Path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" // Coordinates for the square shape
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </Svg>
              )
              : (
                <Svg style={styles.icon} viewBox="0 0 24 24">
                  <Rect
                    x="3" // Starting x-coordinate
                    y="3" // Starting y-coordinate
                    width="18" // Width of the square
                    height="18" // Height of the square
                    rx="2" // Corner radius (rounded corners)
                    ry="2" // Corner radius for y-axis
                    stroke="currentColor" // Outline color
                    strokeWidth={2} // Outline thickness
                    fill="none" // No fill color
                  />
                </Svg>
              )
            }
            <Text> FDW can be interviewed by in person</Text>
          </View>
          <View>
            <View style={{flexDirection: 'row', fontWeight: 'bold', marginBottom: 6}}>
              <Text style={{marginRight: 10}}>(E)</Text>
              <Text>OTHER REMARKS</Text>
            </View>
          </View>
          <View style={{marginBottom: 70}}>
            <View style={styles.formText}>
              <View style={[styles.fullWidthUnderline, {marginLeft: 0, lineHeight: 1}]}>
                <Text> {data.other_remarks ?? ' '}</Text>
              </View>
            </View>
          </View>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            <View style={{width: '50%', paddingRight: 5}}>
              <View style={[styles.fullWidthUnderline, {marginLeft: 0, marginBottom: 5}]}></View>
              <Text>FDW Name and Signature</Text>
              <Text>Date:</Text>
            </View>
            <View style={{width: '50%', paddingLeft: 5}}>
              <View style={[styles.fullWidthUnderline, {marginBottom: 5}]}></View>
              <Text style={{paddingLeft: 5}}>EA Personnel Name and Registration Number</Text>
              <Text style={{paddingLeft: 5}}>Date:</Text>
            </View>
          </View>
          <Text style={{marginBottom: 70}}>I have gone through the biodata of this FDW and confirm that I would like to employ her</Text>
          <View style={{flexDirection: 'row', marginBottom: 6}}>
            <View style={{width: '50%', paddingRight: 5}}>
              <View style={[styles.fullWidthUnderline, {marginLeft: 0, marginBottom: 5}]}></View>
              <Text>Employer Name and NRIC No.</Text>
              <Text>Date:</Text>
            </View>
          </View>
          <View style={styles.center}>
            <Text style={{fontSize: 12}}>***************</Text>
          </View>
          <Text style={{marginBottom: 4, fontWeight: 'bold'}}>IMPORTANT NOTES FOR EMPLOYERS WHEN USING THE SERVICES OF AN EA</Text>
          <View style={styles.list}>
            <View style={styles.listItem}>
                <Text style={styles.bullet}>•</Text> {/* Bullet point */}
                <Text style={styles.itemText}>
                  Do consider asking for an FDW who is able to communicate in a language you require, and interview her (in person/phone/videoconference) to ensure that she can communicate adequately.
                </Text> {/* List item text */}
            </View>
            <View style={styles.listItem}>
                <Text style={styles.bullet}>•</Text> {/* Bullet point */}
                <Text style={styles.itemText}>
                Do consider requesting for an FDW who has a proven ability to perform the chores you require, for example, performing household chores (especially if she is required to hang laundry from a high-rise unit), cooking and caring for young children or the elderly.
                </Text> {/* List item text */}
            </View>
            <View style={styles.listItem}>
                <Text style={styles.bullet}>•</Text> {/* Bullet point */}
                <Text style={styles.itemText}>
                Do work together with the EA to ensure that a suitable FDW is matched to you according to your needs and requirements. You may wish to pay special attention to your prospective FDW&apos;s employment history and feedback from the FDW&apos;s previous employer(s) before employing her.
                </Text> {/* List item text */}
            </View>
          </View>
        </View>
      </Page>
      </Document>
    // </PDFViewer>
  );
};

const styles = StyleSheet.create({
  body: {
    padding: 40,
    fontSize: 10,
  },
  header: {
    marginBottom: 20,
  },
  logo: {
    maxWidth: 90,
    maxHeight: 70,
    marginBottom: 10,
   
  },
  section: {
    marginBottom: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  photo: {
    maxHeight: 150,    /* batas maksimal tinggi */
    width: 'auto',          /* biar aspect ratio tetap */
    height: 'auto',
  },

  normalPadding: {
    marginLeft: 10,
    marginRight: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
  center: {
    textAlign: 'center'
  },
  fullWidthUnderline: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: 'black',
    marginLeft: 8,
    flex: 1,
  },
  formText: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  checkbox: {
    width: 10, // Adjust size of the checkbox
    height: 10,
    borderWidth: 1, // Border thickness for the checkbox
    borderColor: 'black',
    marginRight: 20, // Spacing between checkbox and text
  },
  checkboxWithLabel: {
    width: 10, // Adjust size of the checkbox
    height: 10,
    borderWidth: 1, // Border thickness for the checkbox
    borderColor: 'black',
    marginLeft: 15
  },
  icon: {
    width: 12, // Reduced width
    height: 12, // Reduced height
    marginRight: 15, // Smaller spacing between icon and text
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    // borderWidth: 1,
    // borderColor: 'black',
    marginBottom: 6,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableRow2: {
    flexDirection: 'row',
  },
  tableRow3: {
    flexDirection: 'row',
    minHeight: 40,
  },
  tableCell: {
    // flex: 1, // Adjust cell width
    borderWidth: 1, // Add border to cells
    borderColor: 'black',
    padding: 5,
    fontSize: 10,
  },
  tableCellMerged: {
    // flex: 1, // Adjust cell width
    flexDirection: 'column',
    // borderWidth: 1, // Add border to cells
    // borderColor: 'black',
    fontSize: 10,
  },
  headerCell: {
    textAlign: 'center',
    backgroundColor: '#f0f0f0', // Add background for header
    fontWeight: 'bold',
  },
  list: {
    margin: 10, // Add margin around the list
    padding: 0,
  },
  listItem: {
    flexDirection: 'row', // Allows bullet and text to be side by side
    marginBottom: 3, // Space between list items
  },
  bullet: {
    width: 10, // Size of the bullet
    fontSize: 10, // Bullet size
    marginRight: 5, // Space between bullet and text
  },
  itemText: {
    fontSize: 9, // Text size
  },  
});

ExportPDFBiodataSupplier.propTypes = {
  data: PropTypes.object.isRequired,
  supplier: PropTypes.object.isRequired
};

export default ExportPDFBiodataSupplier;
